'use client';
import { walkthroughRunnerRegistry } from '@unifyapps/blocks/registry/walkthrough';
import { useInterfaceResourceStrategy } from '@unifyapps/carbon/no-code/context/InterfaceResourceStrategyProvider';
import { InterfaceClient } from '@unifyapps/carbon/no-code/stores/InterfaceStore';
import { InterfaceWalkthroughProvider } from '@unifyapps/carbon/no-code/walkthroughs/components/InterfaceWalkthroughProvider';

function InterfaceWalkthroughContainer(props: React.PropsWithChildren<{ interfaceId: string }>) {
  const { children, interfaceId } = props;
  const { strategy } = useInterfaceResourceStrategy();

  return (
    <InterfaceWalkthroughProvider
      client={InterfaceClient.UA_MATRIX}
      instanceId={interfaceId}
      registry={walkthroughRunnerRegistry}
      strategy={strategy}
    >
      {children}
    </InterfaceWalkthroughProvider>
  );
}

export default InterfaceWalkthroughContainer;
